import React from 'react';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

/**
 * Presentational component for certificates table
 * @param {Array.<object>}   certificates    Array of certificate objects  {id: <integer>, name: <string>}
 * @param {Array.<integer>}  selected        Array of ids of the selected certificates
 * @param {Function.<Event>} onRowClick      The callback which triggers when the certificates table row was clicked
 */
const Certificates = ({certificates, selected, onRowClick, intl}) => {

    const isSelected = (id) => {
        return selected.indexOf(id) !== -1;
    };

    return (
        <div className="row">
            <div className="col">

                <div className="table-rep-plugin">
                    <div className="table-wrapper">
                        <div className="table-responsive b-0">
                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th/>
                                    <th>#</th>
                                    <th>{intl.formatMessage(messages.certificates)}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    certificates
                                        .filter(c => !c.hidden)

                                        .map(c =>
                                            <tr
                                                key={c.id}
                                                className={isSelected(c.id) ? 'clickable selected-certificate-row' : 'clickable'}
                                                onClick={() => onRowClick(c.id)} >

                                                <td>
                                                    <input
                                                        readOnly={true}
                                                        type="checkbox"
                                                        className="clickable"
                                                        checked={isSelected(c.id)} />
                                                </td>
                                                <td>
                                                    {c.id}
                                                </td>
                                                <td>
                                                    {c.name}
                                                </td>
                                            </tr>
                                        )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );

};

export default injectIntl(Certificates);


// WEBPACK FOOTER //
// ./web/src/components/certificates/Certificates.jsx